import { Card, CardContent, Grid, Icon } from '@mui/material'
import { styled } from '@mui/material/styles'
import Checkbox from 'components/forms/Checkbox'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import DtoCulture from 'referencial/components/cultures/dto/DtoCulture'
import DtoCulturesFamily from 'referencial/components/culturesFamilies/dto/DtoCulturesFamily'
import DtoUsageAgri from 'referencial/components/usage/dto/DtoUsageAgri'
import DtoSandreCode from 'referencial/dto/DtoSandreCode'
import i18n from 'simple-react-i18n'
import { CardTitle } from 'components/card/NewCard'
import Input from '../../../components/forms/Input'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import Textarea from '../../../components/forms/Textarea'
import DtoInstallationWithGeoItem from '../../../installation/components/installations/dto/DtoInstallationWithGeoItem'
import CityDto from '../../../referencial/components/city/dto/CityDto'
import DtoDeclarationVolumes from '../../../survey/dto/DtoDeclarationVolumes'
import { formatMilliers } from 'utils/StringUtil'

const FieldsetStyle = styled('fieldset')({
    borderRadius: 5,
    paddingBottom: 0,
})

const LegendStyle = styled('legend')({
    padding: '0 4',
    display: 'flex',
    alignItems: 'center',
})

class VolumesPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            volumes: props.volumes,
            point: {},
        }
    }

    onChangeValue = (obj) => {
        const { volumes } = this.props
        this.props.onChange({
            ...volumes,
            ...obj,
        })
    }

    onSelectPoint = (point) => {
        const { citiesIndex, volumes } = this.props
        const city = citiesIndex[point.townCode] || {}
        this.setState({ point: { ...point, city: `${city.code || ''} ${city.name || ''}` } })
        this.props.onChange({
            ...volumes,
            idInstallation: point.id,
        })
    }

    getSelectedPeriod = (idPeriode, usagePeriodes) => {
        return !!usagePeriodes.find((p) => p.idNbPeriode === idPeriode)
    }

    getUsagePanel = (usage) => {
        const { usages, cultures, culturesFamilies, sandreCodes, modesIrrigations } = this.props

        const usagesPeriodes = sandreCodes.filter((code) => code.field === 'USAGES.PERIODES')
        const usagesPeriodesDetails = sandreCodes.filter((code) => code.field === 'USAGES.PERIODES_DETAILS')
        const usageSaisonnal = (usage.link_periodes || []).find((p) => p.idPeriode === 2)
        const usageAnnuel = (usage.link_periodes || []).find((p) => p.idPeriode === 1)

        const usageFound = usage?.idUsage ? (usages.find((u) => u.idUsage === usage.idUsage) || {}).description : ''
        const culture = usage?.idCulture ? cultures.find((c) => c.id === usage.idCulture) : {}
        const culturesFamily = culture.idFamille ? (culturesFamilies.find((cF) => cF.id === culture.idFamille) || {}).name : ''

        const irrigationMode = usage?.irrigationMode ? (modesIrrigations.find((iM) => iM.id === usage.irrigationMode) || {}).name : ''
        const irrigationType = usage?.irrigationType ? (sandreCodes.find((c) => c.field === 'IRRIGATION.CATEGORIES' && c.code === usage.irrigationType) || {}).name : ''
        const groundType = usage?.groundType ? (sandreCodes.find((c) => c.field === 'USAGES.TYPES_SOLS' && c.code === usage.groundType) || {}).name : ''
        const groundDepth = usage?.groundDepth ? (sandreCodes.find((c) => c.field === 'USAGES.PROFONDEUR_SOLS' && c.code === usage.groundDepth) || {}).name : ''
        const prelevementRequest = usage?.requestPrelevement ? (sandreCodes.find((c) => c.field === 'USAGES.TYPES' && c.code === usage.requestPrelevement) || {}).name : ''

        return (
            <FieldsetStyle>
                <LegendStyle>{i18n.usage}</LegendStyle>
                <Grid container spacing={1}>
                    <Grid size={4}><Input title={i18n.type} value={usageFound} disabled /></Grid>
                    {usage.idCulture ? (
                        <>
                            <Grid size={12} container spacing={1}>
                                <Grid size={4}><Input title={i18n.culturesFamily} value={culturesFamily} disabled /></Grid>
                                <Grid size={4}><Input title={i18n.culture} value={culture.name} disabled /></Grid>
                            </Grid>
                            <Grid size={12} container spacing={1}>
                                <Grid size={4}><Input title={i18n.areaha} value={usage.area} disabled /></Grid>
                                <Grid size={4}><Input title={i18n.mainIrrigationType} value={irrigationType} disabled /></Grid>
                                <Grid size={4}><Input title={i18n.modeIrrigation} value={irrigationMode} disabled /></Grid>
                            </Grid>
                            <Grid size={12} container spacing={1}>
                                <Grid size={4}><Input title={i18n.groundType} value={groundType} disabled /></Grid>
                                <Grid size={4}><Input title={i18n.groundDepth} value={groundDepth} disabled /></Grid>
                                <Grid size={4}><Input title={i18n.requestPrelevement} value={prelevementRequest} disabled /></Grid>
                            </Grid>
                        </>
                    ) : undefined}
                    {usage?.link_periodes?.length ? (
                        <>
                            <Grid size={4}>
                                <Select
                                    col={4}
                                    label={i18n.usePeriod}
                                    value={usageSaisonnal ? 2 : usageAnnuel ? 1 : null}
                                    options={usagesPeriodes}
                                    disabled
                                />
                            </Grid>
                            <Grid size={2}>
                                {usageSaisonnal && usagesPeriodesDetails.map((p) => (
                                    <Checkbox
                                        label={p.name}
                                        col={2}
                                        value={p.code}
                                        checked={this.getSelectedPeriod(p.code, usage.link_periodes)}
                                        disabled
                                        key={p.code}
                                    />
                                ))}
                            </Grid>
                        </>
                    ) : undefined}
                </Grid>
            </FieldsetStyle>
        )
    }

    render = () => {
        const { volumes, disabled, newVolumes, points } = this.props
        const { point } = this.state
        const pointInfos = volumes.pointInfos && volumes.pointInfos.id ? volumes.pointInfos : point

        return (
            <Grid container spacing={1}>
                {newVolumes && (
                    <Grid size={6}>
                        <Select
                            id='point'
                            label={i18n.pointPrelevement}
                            value={pointInfos.id}
                            options={points}
                            keyValue='id'
                            keyLabel='code'
                            displayWithCode
                            onChange={(_, v) => this.onSelectPoint(v)}
                            disabled={disabled}
                            obligatory
                        />
                    </Grid>
                )}
                <Grid size={12}>
                    <Card>
                        <CardTitle title={`${i18n.pointPrelevement} ${pointInfos.code || ''}`} />
                        <CardContent>
                            <span className='bold'>{pointInfos.city || ''}</span><br />
                            <span>{`${pointInfos.code ? `${pointInfos.code} - ` : ''}${`${pointInfos.parcel || ''} ${pointInfos.section || ''}${pointInfos.location ? ` - ${pointInfos.location}` : ''}`}`}</span>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid size={12}>{volumes.link_usages && this.getUsagePanel(volumes.link_usages)}</Grid>
                <Grid size={12}>
                    <FieldsetStyle>
                        <LegendStyle>{volumes.idSurvey ? <Icon style={{ marginRight: 4 }}>description</Icon> : ''}{i18n.askedLabel}</LegendStyle>
                        <Grid container spacing={1}>
                            <Grid size={3}>
                                {disabled ? (
                                    <Input title={i18n.volume} value={formatMilliers(volumes.askedVolume)} disabled />
                                ) : (
                                    <NumberField
                                        title={i18n.volume}
                                        value={volumes.askedVolume}
                                        onChange={value => this.onChangeValue({ askedVolume: value })}
                                        disabled={volumes.idSurvey || disabled}
                                    />
                                )}
                            </Grid>
                            <Grid size={3}>
                                {disabled ? (
                                    <Input title={i18n.askedLowWaterVolume} value={formatMilliers(volumes.askedLowWaterVolume)} disabled />
                                ) : (
                                    <NumberField
                                        title={i18n.askedLowWaterVolume}
                                        value={volumes.askedLowWaterVolume}
                                        onChange={value => this.onChangeValue({ askedLowWaterVolume: value })}
                                        disabled={volumes.idSurvey || disabled}
                                    />
                                )}
                            </Grid>
                            <Grid size={3}>
                                <NumberField
                                    title={i18n.year}
                                    value={volumes.askedYear}
                                    onChange={value => this.onChangeValue({ askedYear: value })}
                                    disabled={disabled}
                                    obligatory
                                />
                            </Grid>
                        </Grid>
                    </FieldsetStyle>
                </Grid>
                <Grid size={12}>
                    <FieldsetStyle>
                        <LegendStyle>{i18n.attribution}</LegendStyle>
                        <Grid container spacing={1}>
                            <Grid size={3}>
                                {disabled ? (
                                    <Input col={3} title={i18n.volume} value={formatMilliers(volumes.attributedVolume)} disabled />
                                ) : (
                                    <NumberField
                                        col={3}
                                        title={i18n.volume}
                                        value={volumes.attributedVolume}
                                        onChange={value => this.onChangeValue({ attributedVolume: value })}
                                        disabled={disabled}
                                    />
                                )}
                            </Grid>
                            <Grid size={3}>
                                {disabled ? (
                                    <Input title={i18n.lowWater} value={formatMilliers(volumes.attributedLowWaterVolume)} disabled />
                                ) : (
                                    <NumberField
                                        title={i18n.lowWater}
                                        value={volumes.attributedLowWaterVolume}
                                        onChange={value => this.onChangeValue({ attributedLowWaterVolume: value })}
                                        disabled={disabled}
                                    />
                                )}
                            </Grid>
                            <Grid size={3}>
                                <Input
                                    title={i18n.login}
                                    value={volumes.attributionLogin}
                                    onChange={value => this.onChangeValue({ attributionLogin: value })}
                                    disabled={disabled}
                                />
                            </Grid>
                            <Grid size={3}>
                                <SimpleDatePicker
                                    label={i18n.date}
                                    value={volumes.attributionDate}
                                    onChange={value => this.onChangeValue({ attributionDate: value })}
                                    disabled={disabled}
                                />
                            </Grid>
                            <Grid size={12}>
                                <Textarea
                                    title={i18n.comment}
                                    noMargin={false}
                                    value={volumes.attributionComment}
                                    onChange={value => this.onChangeValue({ attributionComment: value })}
                                    disabled={disabled}
                                />
                            </Grid>
                        </Grid>
                    </FieldsetStyle>
                </Grid>
                <Grid size={12}>
                    <FieldsetStyle>
                        <LegendStyle>{i18n.authorisation}</LegendStyle>
                        <Grid container spacing={1}>
                            <Grid size={3}>
                                {disabled ? (
                                    <Input title={i18n.volume} value={formatMilliers(volumes.authorizedVolume)} disabled />
                                ) : (
                                    <NumberField
                                        title={i18n.volume}
                                        value={volumes.authorizedVolume}
                                        onChange={value => this.onChangeValue({ authorizedVolume: value })}
                                        disabled={disabled}
                                    />
                                )}
                            </Grid>
                            <Grid size={3}>
                                {disabled ? (
                                    <Input title={i18n.lowWater} value={formatMilliers(volumes.authorizedLowWaterVolume)} disabled />
                                ) : (
                                    <NumberField
                                        title={i18n.lowWater}
                                        value={volumes.authorizedLowWaterVolume}
                                        onChange={value => this.onChangeValue({ authorizedLowWaterVolume: value })}
                                        disabled={disabled}
                                    />
                                )}
                            </Grid>
                            <Grid size={3}>
                                <Input
                                    title={i18n.login}
                                    value={volumes.authorizedLogin}
                                    onChange={value => this.onChangeValue({ authorizedLogin: value })}
                                    disabled={disabled}
                                />
                            </Grid>
                            <Grid size={3}>
                                <SimpleDatePicker
                                    label={i18n.date}
                                    value={volumes.authorizedDate}
                                    onChange={value => this.onChangeValue({ authorizedDate: value })}
                                    disabled={disabled}
                                    calendarPosition='top'
                                />
                            </Grid>
                            <Grid size={3}>
                                <NumberField
                                    title={i18n.flow}
                                    value={volumes.authorizedFlow}
                                    onChange={value => this.onChangeValue({ authorizedFlow: value })}
                                    disabled={disabled}
                                />
                            </Grid>
                            <Grid size={12}>
                                <Textarea
                                    title={i18n.comment}
                                    noMargin={false}
                                    value={volumes.authorizedComment}
                                    onChange={value => this.onChangeValue({ authorizedComment: value })}
                                    disabled={disabled}
                                />
                            </Grid>
                        </Grid>
                    </FieldsetStyle>
                </Grid>
            </Grid>
        )
    }
}

VolumesPanel.propTypes = {
    disabled: PropTypes.bool,
    title: PropTypes.string,
    newVolumes: PropTypes.bool,
    volumes: PropTypes.instanceOf(DtoDeclarationVolumes),
    points: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallationWithGeoItem)),
    citiesIndex: PropTypes.arrayOf(PropTypes.instanceOf(CityDto)),
    usages: PropTypes.arrayOf(PropTypes.instanceOf(DtoUsageAgri)),
    cultures: PropTypes.arrayOf(PropTypes.instanceOf(DtoCulture)),
    culturesFamilies: PropTypes.arrayOf(PropTypes.instanceOf(DtoCulturesFamily)),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    modesIrrigations: PropTypes.arrayOf(PropTypes.instanceOf({})),
    onChange: PropTypes.func,
}

const mapStateToProps = (store) => {
    return {
        citiesIndex: store.CityReducer.citiesIndex,
        usages: store.UsageReducer.usages,
        cultures: store.CultureReducer.cultures,
        culturesFamilies: store.CulturesFamilyReducer.culturesFamilies,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        modesIrrigations: store.AgriReducer.modesIrrigations,
    }
}

export default connect(mapStateToProps)(VolumesPanel)